var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSeallist16(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-208)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: -8.8818e-16,
    width: 16,
    height: 16,
    fill: "none",
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(48,2)",
    d: "m168-2c-1.1153-1e-7 -1.4598 1.5615-2.4902 1.9883-1.0304 0.4268-2.3774-0.43316-3.166 0.35547-0.78863 0.78862 0.0713 2.1356-0.35547 3.166-0.4268 1.0304-1.9883 1.375-1.9883 2.4902 0 1.1153 1.5615 1.4598 1.9883 2.4902s-0.43316 2.3774 0.35547 3.166c0.78862 0.78862 2.1356-0.07133 3.166 0.35547 1.0304 0.4268 1.375 1.9883 2.4902 1.9883 0.41535 0 0.72322-0.2159 1-0.50977v-7.4902c6e-5 -0.55226 0.44774-0.99994 1-1h5.4902c-0.49521-0.46642-1.2107-0.84358-1.4785-1.4902-0.4268-1.0304 0.43316-2.3774-0.35547-3.166-0.78862-0.78863-2.1356 0.071332-3.166-0.35547-1.0304-0.4268-1.375-1.9883-2.4902-1.9883z",
    fill: "#ff8080",
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m216 3c-2.7496 0-5 2.2504-5 5 0 2.7496 2.2504 5 5 5 0.34237 0 0.67649-0.03516 1-0.10156v-1.0273a4 4 0 0 1-1 0.12891 4 4 0 0 1-4-4 4 4 0 0 1 4-4 4 4 0 0 1 3.8711 3h1.0274c-0.46688-2.2746-2.4912-4-4.8984-4z",
    color: "#000000",
    fill: "#fff",
    strokeLinecap: "round",
    style: {
      InkscapeStroke: "none",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218 8h6v8h-6z",
    color: "#000000",
    fill: "#4d4d4d",
    strokeLinejoin: "round",
    style: {
      InkscapeStroke: "none",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219,
    y: 9,
    width: 4,
    height: 1,
    fill: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 2,
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219,
    y: 11,
    width: 4,
    height: 1,
    fill: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 2,
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219,
    y: 13,
    width: 4,
    height: 1,
    fill: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 2,
    style: {
      paintOrder: "markers stroke fill"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeallist16);
export default __webpack_public_path__ + "static/media/seal.list.16.c237562c3952e746dececf7adf3e855d.svg";
export { ForwardRef as ReactComponent };